// frontend/admin-portal/src/components/settings/SettingsTabs.jsx
import React from "react";

export default function SettingsTabs({ tabs, active, onChange }) {
  return (
    <div className="fh-settings-tabs">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`fh-settings-tab ${active === t.id ? "fh-settings-tab--active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
